function SingleStatComponent({ value, description }) {
    return (
      <div 
        className="p-6 border shadow-sm transition-all duration-200 hover:shadow-md"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          borderColor: 'color-mix(in srgb, var(--color-muted) 50%, transparent)'
        }}
      >
        <div className="flex flex-col items-center justify-center text-center">
          <div 
            className="text-4xl font-bold mb-2"
            style={{ color: 'var(--color-primary)' }}
          >
            {value}
          </div>
          <div 
            className="text-sm font-medium"
            style={{ color: 'var(--color-muted)' }}
          >
            {description}
          </div>
        </div>
      </div>
    );
  }

export { SingleStatComponent }